import { render, staticRenderFns } from "./MarketViewLiveDetailV5Classic.vue?vue&type=template&id=7f809e1e&scoped=true"
import script from "./MarketViewLiveDetailV5Classic.vue?vue&type=script&lang=js"
export * from "./MarketViewLiveDetailV5Classic.vue?vue&type=script&lang=js"
import style0 from "./MarketViewLiveDetailV5Classic.vue?vue&type=style&index=0&id=7f809e1e&prod&scoped=true&lang=css"
import style1 from "./MarketViewLiveDetailV5Classic.vue?vue&type=style&index=1&id=7f809e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f809e1e",
  null
  
)

export default component.exports